import { getCtaRef } from "../analytics/common";
import { getFeature } from "./features";

const trackCtaClickInOptimizely = async (ctaReference) => {
  if (!ctaReference) {
    return;
  }

  const matchedTracker = window.asos.pdp.config.featuresCtaTracking.find(
    (feature) => feature.matchCta.toLowerCase() === ctaReference.toLowerCase()
  )?.trackingKey;

  if (matchedTracker) {
    const { track } = getFeature(matchedTracker);
    await track(matchedTracker);
  }
};

export const trackCtaRefInOptimizely = async () => {
  let ctaRef = getCtaRef();
  if (ctaRef) {
    ctaRef = ctaRef.split("_")[0].toLowerCase();
    await trackCtaClickInOptimizely(ctaRef);
  }
};

export { trackCtaClickInOptimizely };

